import { ApiSchema } from "@api-types";
import { captureException } from "@sentry/react";
import { ErrorView } from "components/ErrorView/ErrorView";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { hasPolicy$ } from "helpers/hasPolicy";
import React, { useEffect, useState } from "react";
import { useSubscription } from "rsm/useSubscription";
import { of } from "rxjs";
import { getFFService } from "services/ff.service";

const PageRoute: React.FC<{
  El: React.LazyExoticComponent<React.FC<{}>>;
  inPolicy?: ApiSchema.Policy;
  ff?: ApiSchema.FF;
}> = ({ El, inPolicy, ff }) => {
  const [isAllowed, setIsAllowed] = useState<boolean | null>(() => (inPolicy ? null : true));
  useSubscription(
    inPolicy ? hasPolicy$(inPolicy) : of(true),
    (hasPolicy) => {
      setIsAllowed(inPolicy && !hasPolicy ? false : true);
    },
    [inPolicy],
  );
  useSubscription(
    ff ? getFFService().featureEnabled$(ff) : of(true),
    (hasFeature) => {
      if (!hasFeature) {
        window.location.href = "/";
      }
    },
    [ff],
  );

  useEffect(() => {
    if (isAllowed !== false) return;
    captureException(new Error("PageRoute is not allowed"), {
      tags: {
        inPolicy: inPolicy ?? "n/a",
        path: window.location.pathname,
      },
    });
  }, [isAllowed, inPolicy]);

  if (isAllowed === true) {
    return (
      <React.Suspense fallback={<LoadingPage />}>
        <El />
      </React.Suspense>
    );
  } else if (isAllowed === false) {
    return (
      <ErrorView
        errorCode={403}
        title="Access denied"
        summary="You are not authorized to access this page."
        showHomeButton={true}
      />
    );
  }

  return <LoadingPage />;
};

export default PageRoute;
